import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { AnimatePresence } from 'framer-motion'

import { TextField, Animation } from 'components'

const Container = styled.div`
    overflow: hidden;
`

const Title = styled.div`
    font-size: 3rem;
    font-weight: bolder;
    align-self: flex-start;
`

const Subtitle = styled.div`
    font-size: 1rem;
    /* font-weight: bold; */
    align-self: flex-start;
`

const Field = styled.div`
    margin: 1rem 0;
    padding: 0.2rem 0.5rem;
    width: 100%;
    border-bottom: 2px solid var(--focus-color);
`

const NameTab = props => {
    const {
        value,
        onChange,
        onSubmit,
    } = props

    const onKeyPressHandler = (event) => {
        event.charCode === 13 && onSubmit();
    }

    return (
        <Container>
            <Title>Welcome!</Title>
            <Subtitle>How do we address you?</Subtitle>
            <Animation animation='exitRight'>
                <Field>
                    <TextField value={value} autoFocus
                        onChange={(event) => onChange(event.target.value)} 
                        onKeyPress={onKeyPressHandler}/>
                </Field>
            </Animation>
        </Container>
    )
}

export default NameTab

NameTab.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    onSubmit: PropTypes.func
}